import { Box, Button } from "@mui/material";
import { DeleteOutline } from "@mui/icons-material";
import { tokens } from '../../theme/index';
import { useLanguage } from '../../localization';

function ClearAllData({ onClear }) {
    const { t } = useLanguage();
    
    return (
        <Box sx={{ p: 2, textAlign: 'center' }}>
            <Button
                variant="contained"
                startIcon={<DeleteOutline />}
                onClick={onClear}
                sx={{
                    backgroundColor: tokens.colors.primary.light,
                }}
            >
                {t('mobile.clearAllData')}
            </Button>
        </Box>);
}

export default ClearAllData;